type SetupCallback = (resolve: () => void) => void;

export default function sleep(setup: SetupCallback): Promise<void> {
  return new Promise<void>((resolve) => {
    setup(() => {
      requestAnimationFrame(() => resolve());
    });
  });
}
